import React from "react";
import { SingleUserTable11, SingleUserTable19, SingleUserTable24 } from "../allTables/allTable";
import UserService from "../../services/user.service";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import instagram from "../../../assets/img/brand/instagram_2111463 1.png";
import xIcon from "../../../assets/img/brand/sl_z_072523_61700_01 1.png";
import Reddit from "../../../assets/img/brand/reddit 1.png";
import { Card, Col, Form, FormGroup, Row } from "react-bootstrap";

export function SingleUserTable() {
  const [data, setData] = useState([]);
  const [country, setCountry] = useState("");
  const [iconData, setIconData] = useState("");
  const location = useLocation();
  const id = location?.state?.id;
  const getAllUserData = async () => {
    const response = await UserService.GetSingleUserData(id);
    setData(response.data.data.userHistoryData);
    setIconData(response.data.data.userData);
    setCountry(response.data.data.userHistoryData.countryName);
  };

  useEffect(() => {
    getAllUserData();
  }, []);

  const raceDetailLength11 = data.filter(
    (item) => item?.raceDetail?.length === 10
  );
  const raceDetailLength19 = data.filter(
    (item) => item?.raceDetail?.length === 18
  );
  const raceDetailLength24 = data.filter(
    (item) => item?.raceDetail?.length === 24
  );

  return (
    <>
      <div className="page-header2"></div>

      <Card className="custom-card">
        <Card.Body>
          <Row>
            <div>
              <div className="border-bottom mb-3">


                
                <FormGroup className="form-group">
                  <Row className=" row-sm">
                    <div
                      className="me-auto d-flex justify-content-start"
                      style={{ fontWeight: 600, fontSize: "20px" }}>
                      User Detail
                    </div>
                  </Row>
                </FormGroup>
              </div>
              <div>
                <div className="row">
                  <FormGroup className="form-group">
                    <Row className=" row-sm">
                      <Col md={2} className="d-flex align-items-center">
                        <Form.Label className="text-dark">
                          {"First Name"} :
                        </Form.Label>
                      </Col>
                      <Col md={4}>
                        <Form.Control value={iconData.firstName} disabled />
                      </Col>
                      <Col md={2} className="d-flex align-items-center">
                        <Form.Label className="text-dark">
                          {"Last Name"} :
                        </Form.Label>
                      </Col>
                      <Col md={4}>
                        <Form.Control value={iconData.lastName} disabled />
                      </Col>
                    </Row>
                  </FormGroup>

                  <>
                    <FormGroup className="form-group">
                      <Row className=" row-sm">
                        <Col md={2} className="d-flex align-items-center">
                          <Form.Label className="text-dark">
                            {"Email"} :
                          </Form.Label>
                        </Col>
                        <Col md={4}>
                          <Form.Control value={iconData.email} disabled />
                        </Col>
                        <Col md={2} className="d-flex align-items-center">
                          <Form.Label className="text-dark">
                            {"Mobile Number"} :
                          </Form.Label>
                        </Col>
                        <Col md={4}>
                          <Form.Control
                            value={iconData.mobileNumber}
                            disabled
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                    <FormGroup className="form-group">
                      <Row className="row-sm">
                        <Col md={2} className="d-flex align-items-center">
                          <Form.Label className="text-dark">
                            {"Group"} :
                          </Form.Label>
                        </Col>
                        {iconData?.groups?.length > 0 ? (
                          <Col md={4} className="d-flex gap-2">
                            {iconData?.groups?.map((group, index) => (
                              <div className="d-flex gap-2" key={index}>
                                <span className="bg-light text-dark p-2">
                                  {group?.name}
                                </span>
                              </div>
                            ))}
                          </Col>
                        ) : (
                          <Col md={4}>
                            <div className="d-flex gap-2">
                              <span className="bg-light text-dark p-2">
                                {"--"}
                              </span>
                            </div>
                          </Col>
                        )}
                        <Col md={2} className="d-flex align-items-center">
                          <Form.Label className="text-dark">
                            {"Social Media"} :
                          </Form.Label>
                        </Col>
                        <Col md={4}>
                          {iconData.socialDetails &&
                            iconData.socialDetails[0]?.instagramAccount && (
                              <button
                                className="btn  btn-sm"
                                onClick={() =>
                                  window.open(
                                    "https://www.instagram.com/" +
                                      iconData.socialDetails[0]
                                        ?.instagramAccount
                                  )
                                }>
                                <img
                                  src={instagram}
                                  width="30px"
                                  height="30px"
                                  alt=""
                                />
                              </button>
                            )}
                          {iconData.socialDetails &&
                            iconData.socialDetails[0]?.redditAccount && (
                              <button
                                style={{ marginLeft: "10px" }}
                                className="btn  btn-sm"
                                onClick={() =>
                                  window.open(
                                    "https://www.reddit.com/" +
                                      iconData.socialDetails[0]?.redditAccount
                                  )
                                }>
                                <img
                                  src={Reddit}
                                  width="30px"
                                  height="30px"
                                  alt=""
                                />
                              </button>
                            )}
                          {iconData.socialDetails &&
                            iconData.socialDetails[0]?.Xaccount && (
                              <button
                                style={{ marginLeft: "10px" }}
                                className="btn  btn-sm"
                                onClick={() =>
                                  window.open(
                                    "https://twitter.com/" +
                                      iconData.socialDetails[0]?.Xaccount
                                  )
                                }>
                                <img
                                  src={xIcon}
                                  width="30px"
                                  height="30px"
                                  alt=""
                                />
                              </button>
                            )}
                        </Col>
                      </Row>
                    </FormGroup>
                  </>
                </div>
              </div>
            </div>
          </Row>
        </Card.Body>
      </Card>
      <SingleUserTable11 data={raceDetailLength11} country={country} />
      <SingleUserTable19 data={raceDetailLength19} country={country} />
      <SingleUserTable24 data={raceDetailLength24} country={country} />
    </>
  );
}
